import { myAxios } from "./axios";

export function getRoles(data, { page, limit }) {
  let config = {
    params: {
      page,
      limit,
      name: data ? data.txt : null,
    },
  };
  return myAxios.get("/roles", config);
}

export function getRolesDropdown(data) {
  let config = {
    params: {
      name: data ? data.txt : null,
    },
  };
  return myAxios.get("/roles", config);
}

export function getRole(id) {
  return myAxios.get("/roles/" + id);
}

export function addRole(data) {
  return myAxios.post("/roles/create", data);
}

export function getAllPermissions(data) {
  return myAxios.get("/roles/permissions");
}

export function editRole(id, data) {
  return myAxios.put(`roles/edit/${id}`, data);
}

export function deleteRole(id) {
  return myAxios.delete(`/roles/delete/${id}`);
}
